import React from "react";
import {FooterSquareStyled} from "./footer.styled";
import {
  FaFacebookF,
  FaInstagram,
  FaTwitter,
  FaLinkedinIn,
  FaGithub,
} from "react-icons/fa";

const FooterSquare = () => {
  return (
    <FooterSquareStyled>
      <h3>NajamTech AI</h3>
      <p className="mb-3">Orangi Town Pakistan</p>
      <p className="mb-1">Cell no: +92 3272750075</p>
      <p className="mb-1">smnajamulhaque@gmail.com</p>
      <ul>
        <li>
          <a
            href="https://www.linkedin.com/in/s-m-junaid-ul-haque/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: 'white' }} // Add this style
          >
            <FaLinkedinIn />
          </a>
        </li>
      </ul>
    </FooterSquareStyled>
  );
  
};

export default FooterSquare;
